import { render } from "./CBox.vue?vue&type=template&id=4f4b069e&scoped=true"
import script from "./CBox.vue?vue&type=script&lang=js"
export * from "./CBox.vue?vue&type=script&lang=js"

import "./CBox.vue?vue&type=style&index=0&id=4f4b069e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f4b069e"]])

export default __exports__